import { AgmCoreModule } from '@agm/core';
import { Overlay, OverlayContainer } from '@angular/cdk/overlay';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatPaginatorIntl, MAT_DIALOG_DEFAULT_OPTIONS, MAT_MENU_SCROLL_STRATEGY } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppComponent } from './app.component';
import { routing } from './app.routing';
import { AppService } from './app.service';
import { AppSettings } from './app.settings';
import { InMaintenanceComponent } from './pages/in-maintenance/in-maintenance.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { PagesComponent } from './pages/pages.component';
import { AddressService } from './service/address.service';
import { AdjuntoService } from './service/adjunto.service';
import { AmazonS3Service } from './service/amazon-s3.service';
import { AuthGuard } from './service/auth/auth.guard';
import { AuthService } from './service/auth/auth.service';
import { BannerService } from './service/banner.service';
import { CityService } from './service/city.service';
import { ClasificacionService } from './service/clasificacion.service';
import { DetallePedidoService } from './service/detalle-pedido.service';
import { EstadoNovedadService } from './service/estado-novedad.service';
import { ExcelService } from './service/excel.service';
import { MensajeNovedadService } from './service/mensaje-novedad.service';
import { MenuService } from './service/menu.service';
import { MovimientoService } from './service/movimiento.service';
import { NovedadService } from './service/novedad.service';
import { ParametroService } from './service/parametro.service';
import { ParteService } from './service/parte.service';
import { PedidoService } from './service/pedido.service';
import { ProvinceService } from './service/province.service';
import { ReportsService } from './service/reports.service';
import { ShoppingCartService } from './service/shopping-cart.service';
import { SolicitudAutorizacionVinService } from './service/solicitud-authorizacion-vin.service';
import { TerceroService } from './service/tercero.service';
import { TipoIdentificacionService } from './service/tipo-identificacion.service';
import { TipoNovedadService } from './service/tipo-novedad.service';
import { VehiculoService } from './service/vehiculo.service';
import { WishlistService } from './service/wishlist.service';
import { SharedModule } from './shared/shared.module';
import { BreadcrumbComponent } from './theme/components/breadcrumb/breadcrumb.component';
import { FooterComponent } from './theme/components/footer/footer.component';
import { MenuComponent } from './theme/components/menu/menu.component';
import { OptionsComponent } from './theme/components/options/options.component';
import { SidenavMenuComponent } from './theme/components/sidenav-menu/sidenav-menu.component';
import { TopMenuComponent } from './theme/components/top-menu/top-menu.component';
import { AppInterceptor } from './theme/utils/app-interceptor';
import { CustomOverlayContainer } from './theme/utils/custom-overlay-container';
import { menuScrollStrategy } from './theme/utils/scroll-strategy';
import { getSpanishPaginatorIntl } from './utils/spanish-paginator-intl';
import { IframePageComponent } from './pages/iframe-page/iframe-page.component';




@NgModule({
   imports: [
    Ng4LoadingSpinnerModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgxSpinnerModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyB3HQ_Gk_XRt6KitPdiHQNGpVn0NDwQGMI'
    }),
    SharedModule,
    routing
  ],
  declarations: [
    AppComponent,
    PagesComponent,
    NotFoundComponent,
    TopMenuComponent,
    MenuComponent,
    SidenavMenuComponent,
    BreadcrumbComponent,
    OptionsComponent,
    FooterComponent,
    InMaintenanceComponent
  ], 
  providers: [
    AppSettings,
    AppService,   
    { provide: OverlayContainer, useClass: CustomOverlayContainer },
    { provide: MAT_MENU_SCROLL_STRATEGY, useFactory: menuScrollStrategy, deps: [Overlay] },
    { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true },
    TipoIdentificacionService,
    AdjuntoService,
    BannerService,
    TerceroService,
    ParametroService,
    ParteService,
    ClasificacionService,
    AmazonS3Service,
    SolicitudAutorizacionVinService,
    AddressService,
    ProvinceService,
    CityService,
    PedidoService,
    TipoNovedadService,
    VehiculoService,
    EstadoNovedadService,
    NovedadService,
    MensajeNovedadService,
    AuthService,
    AuthGuard,
    MenuService,
    DetallePedidoService,
    ExcelService,
    MovimientoService,
    ShoppingCartService,
    WishlistService,
    ReportsService,
    { provide: MatPaginatorIntl, useValue: getSpanishPaginatorIntl() },
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {hasBackdrop: false}}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }